import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import home from './home.json';
import join from './join.json';
import productDetail from './productDetail.json';
import myPage from './myPage.json';
import orderDetail from './orderDetail.json';
import reviewModal from './reviewModal.json';
import questionnaire from './questionnaire.json';
import order from './order.json';
import footer from './footer.json';
import login from './login.json';
import orderComplete from './orderComplete.json';
import productList from './productList.json';
import header from './header.json';
import faq from './faq.json';
import other from './other.json';
import joinSuccess from './joinSuccess.json';
import stepModal from './stepModal.json';
import loading from './loading.json';
import productDetail_mn from './productDetail_mn.json';
import order_mn from './order_mn.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        home: home,
        join: join,
        productDetail: productDetail,
        myPage: myPage,
        orderDetail: orderDetail,
        reviewModal: reviewModal,
        questionnaire: questionnaire,
        order: order,
        footer: footer,
        login: login,
        orderComplete: orderComplete,
        productList: productList,
        header: header,
        faq: faq,
        other: other,
        joinSuccess: joinSuccess,
        stepModal: stepModal,
        loading: loading,
      },
    },
    mn: {
      translation: {
        home: home,
        join: join,
        productDetail: productDetail_mn,
        myPage: myPage,
        orderDetail: orderDetail,
        reviewModal: reviewModal,
        questionnaire: questionnaire,
        order: order_mn,
        footer: footer,
        login: login,
        orderComplete: orderComplete,
        productList: productList,
        header: header,
        faq: faq,
        other: other,
        joinSuccess: joinSuccess,
        stepModal: stepModal,
        loading: loading,
      },
    },
  },
  lng: 'en',
});
export default i18n;
